<template>
	<div class="time-left-to-order" v-if="showTemplate">
		<template v-if="willBeSentNextWorkDay">{{
			$translate("Eros::Template.timeLeftToOrderStringNextDayP1")
		}}</template>
		<template v-else>{{ $translate("Eros::Template.timeLeftToOrderStringP1") }}</template>
		<span class="availability_1">
			<span class="time-left-to-order-hours" v-if="duration.hours"
				>{{ duration.hours }}{{ $translate("Eros::Template.timeLeftToOrderHourAbbrev") }}&nbsp;</span
			>
			<span class="time-left-to-order-minutes" v-if="duration.minutes"
				>{{ durationMinutes }}{{ $translate("Eros::Template.timeLeftToOrderMinuteAbbrev") }}&nbsp;</span
			>
			{{ durationSeconds }}{{ $translate("Eros::Template.timeLeftToOrderSecondAbbrev") }}
		</span>
		{{ $translate("Eros::Template.timeLeftToOrderStringP2") }}<br />
		<span class="text-muted">
			{{ timeLeftToOrderClause }}
		</span>
	</div>
</template>

<script>
import dayjs from "dayjs";
import TranslationService from "../../../ceres/services/TranslationService";
import { isNullOrUndefined } from "../../../ceres/helper/utils";
import { whenConsented } from "../../helper/whenConsented";
const ApiService = require("../../../ceres/services/ApiService");

export default {
    name: "time-left-to-order",

	props: {
		sampleData: {
			type: Object,
			default() {
				return {};
			}
		},
		waitForConsent: {
			type: Boolean,
			default: true
		}
	},

	inject: {
		itemId: {
			default: null
		}
	},

	data() {
		return {
			momentEnd: null,
			duration: null,
			remainSeconds: 0,
			currentInterval: null,
			isVisible: false,
			isEnabled: App.Eros.Config.item.showTimeLeftToOrder || false,
			timeUntil: App.Eros.BackendConfig?.functions.TimeLeftToOrderUntil || ""
		};
	},

	computed: {
		showTemplate() {
			return !isNullOrUndefined(this.duration) && this.isVisible;
		},

		timeLeftToOrderClause() {
			return TranslationService.translate("Eros::Template.timeLeftToOrderStringP3").replace(
				":time",
				this.nextWorkDayDate +
					TranslationService.translate("Eros::Template.timeLeftToOrderBetweenDateAndTime") +
					(TranslationService.translate("Eros::Template.timeLeftToOrderBetweenDateAndTime") == ""
						? ""
						: " ") +
					this.momentEnd.format("HH") +
					":" +
					this.momentEnd.format("mm")
			);
		},

		durationSeconds() {
			return this.duration.seconds.toString().length == 1
				? "0" + this.duration.seconds.toString()
				: this.duration.seconds.toString();
		},

		durationMinutes() {
			return this.duration.minutes.toString().length == 1
				? "0" + this.duration.minutes.toString()
				: this.duration.minutes.toString();
		},

		willBeSentNextWorkDay() {
			return (
				this.timeUntil.length == 5 &&
				this.timeUntil.includes(":") &&
				parseInt(this.timeUntil.split(":")[0]) <= this.duration.hours
			);
		},

		nextWorkDayDate() {
			return this.willBeSentNextWorkDay
				? dayjs()
						.add(Math.ceil((this.duration.hours - parseInt(this.timeUntil.split(":")[0])) / 24), "days")
						.format(TranslationService.translate("Ceres::Template.devDateFormatMoment")) + " "
				: "";
		},

		currentVariation() {
			return this.$store.getters[`${this.itemId}/currentItemVariation`];
		}
	},

	mounted() {
		if (this.isEnabled) {
			if (this.waitForConsent) {
				whenConsented(
					"",
					() => {
						this.getData();
					},
					() => {}
				);
			} else {
				this.getData();
			}
		}
	},

	methods: {
		getData() {
			if (Object.keys(this.sampleData).length > 0) {
				this.isVisible = true;
				this.momentEnd = dayjs(Date.now()).add(this.sampleData.timeLeft, "seconds");
				this.initializeTimer();
			} else {
				ApiService.get("/rest/erosbackend/item/timeLeft/").done((response) => {
					const timeLeft = response;

					if (timeLeft > 0) {
						if (Object.keys(this.currentVariation).length > 0) {
							this.isVisible = this.currentVariation.variation.availability.id === 1;
						} else {
							this.isVisible = true;
						}

						this.momentEnd = dayjs(Date.now()).add(timeLeft, "seconds");
						this.initializeTimer();
					}
				});
			}
		},

		initializeTimer() {
			clearInterval(this.currentInterval);

			this.getTimeLeftToOrder();
			this.currentInterval = setInterval(() => {
				this.getTimeLeftToOrder();

				if (this.remainSeconds <= 0) {
					this.isVisible = false;
					clearInterval(this.currentInterval);
				}
			}, 1000);
		},

		getTimeLeftToOrder() {
			const momentNow = dayjs(Date.now());

			this.remainSeconds = this.momentEnd.diff(momentNow, "seconds");
			this.duration = this.getDuration(this.remainSeconds);
		},

		getDuration(timeLeft) {
			let totalHours = 0;
			let totalMinutes = 0;
			let totalSeconds = 0;

			if (timeLeft > 0) {
				totalHours = Math.floor(timeLeft / (60 * 60));
				totalSeconds = timeLeft - totalHours * 60 * 60;

				totalMinutes = Math.floor(totalSeconds / 60);
				totalSeconds = totalSeconds - totalMinutes * 60;
			}
			return {
				hours: totalHours,
				minutes: totalMinutes,
				seconds: totalSeconds
			};
		}
	},

	watch: {
		currentVariation: {
			handler(newVariation, oldVariation) {
				if (newVariation !== oldVariation) {
					this.isVisible = newVariation.variation.availability.id === 1;
				}
			}
		}
	}
};
</script>